'use client';

import React from 'react';
import { ListsAutocomplete } from '../ListsAutocomplete';
import useLists from 'src/hooks/lists/useLists';
import { useLayoutControl } from 'src/context/layout';
import { CreateListDialog } from '../CreateListDialog';
import { DeleteListDialog } from '../DeleteListDialog';
import { ReassignListDialog } from '../ReassignListDialog';
import { ShareListDialog } from '../ShareListDialog';

const ListsTableHeader = () => {
  const {
    setShowDeleteListDialog,
    setShowReassignListDialog,
    setShowShareListDialog,
    showDeleteListDialog,
    showReassignListDialog,
    showShareListDialog,
    listToManage,
  } = useLists();

  const { showAddListDialog, setShowAddListDialog } = useLayoutControl();

  const handleCreateListClose = () => {
    setShowAddListDialog(false);
  };

  const handleDeleteListClose = () => {
    setShowDeleteListDialog(false);
  };

  const handleReassignListClose = () => {
    setShowReassignListDialog(false);
  };

  const handleShareListClose = () => {
    setShowShareListDialog(false);
  };

  return (
    <div className="flex items-center justify-between px-4 py-6 border-b border-neutral-300">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-4">
            <ListsAutocomplete />
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <CreateListDialog
          open={showAddListDialog}
          onClose={handleCreateListClose}
        />
        <DeleteListDialog
          open={showDeleteListDialog}
          onClose={handleDeleteListClose}
          listId={Number(listToManage)}
        />
        <ReassignListDialog
          open={showReassignListDialog}
          onClose={handleReassignListClose}
          listId={Number(listToManage)}
        />
        <ShareListDialog
          open={showShareListDialog}
          onClose={handleShareListClose}
          listId={Number(listToManage)}
        />
      </div>
    </div>
  );
};

export default ListsTableHeader;
